export default __webpack_public_path__ + "static/prototyping-1823801064181688297ce12d7d497361.svg";